import React, { useEffect, useState } from "react";
import { Line } from "react-chartjs-2";
import "chart.js/auto";
import dayjs from "dayjs";

import Calendar from "react-calendar";
import "react-calendar/dist/Calendar.css";

import moment from "moment";
import CommonService from "../../services/common.service";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import { useLocation } from "react-router-dom";

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend
);

const TollCollection = () => {
  const location = useLocation();
  const isActiveCentral =
    location.pathname === "/" || location.pathname === "/centralDashboard";
  const isActiveMelli = location.pathname === "/melliDashboard";

  const [activeYearly, setActiveYearly] = useState(1);
  const [loading, setLoading] = useState(false);
  const [graphData, setGraphData] = useState([]);
  const [graphData2, setGraphData2] = useState([]);

  const [showCalendar, setShowCalendar] = useState(false);
  const [showCalendar2, setShowCalendar2] = useState(false);

  const [formdate, setFormdate] = useState();
  const [toDate, setToDate] = useState();

  const [details, setDetails] = useState({
    fromDate: "",
    formatedFromDate: "",
    toDate: "",
    formatedToDate: "",
  });

  const currentDate = new Date();

  const formatMonthYear = (locale, date) => {
    return `${currentDate.getDate()} ${currentDate.toLocaleDateString(locale, {
      month: "long",
    })}, ${currentDate.getFullYear()}`;
  };

  const disableWeekends = ({ date, view }) => {
    // Disable weekends
    if (view === "month") {
      return date.getDay() === 0 || date.getDay() === 6;
    }
  };

  const handleChange = (newValue) => {
    setFormdate(newValue);
    setDetails({
      ...details,
      fromDate: moment(new Date(newValue)).format("YYYY-MM-DD"),
      formatedFromDate: moment(new Date(newValue)).format("DD-MM-YY"),
    });
    setShowCalendar(false);
  };

  const handleChange2 = (newValue) => {
    setToDate(newValue);
    setDetails({
      ...details,
      toDate: moment(new Date(newValue)).format("YYYY-MM-DD"),
      formatedToDate: moment(new Date(newValue)).format("DD-MM-YY"),
    });
    setShowCalendar2(false);
  };

  useEffect(() => {
    fetchData();
  }, [activeYearly]);

  const fetchData = () => {
    setLoading(true);
    const req = {
      type: activeYearly.toString(),
      locid: "",
    };

    CommonService.cmtollCollection(req)
      .then((response) => {
        setLoading(false);
        setGraphData(response.data.filter((item) => item.locid === "35"));
        setGraphData2(response.data.filter((item) => item.locid === "30"));
      })
      .catch((e) => console.log(e));
  };

  const handleYearlyFilter = (from) => {
    setActiveYearly(from);
  };

  const generateLast7DaysData = () => {
    const xx = graphData;
    if (xx.length != 0) {
      const data = xx.map((item) =>
        moment(item.dateormonth, "DD-MM-YYYY HH:mm:ss").format("DD-MM-YY")
      );
      return data;
    } else {
      return;
    }
  };

  const generateLast7YearsData = () => {
    const xx = graphData;
    if (xx.length != 0) {
      const data = xx.map((itm) => itm.dateormonth);
      return data;
    } else {
      return;
    }
  };

  const months = Array.from({ length: dayjs().month() + 1 }, (_, i) =>
    dayjs().month(i).format("MMM")
  );

  const data =
    activeYearly === 1
      ? generateLast7DaysData()
      : activeYearly === 2
      ? months
      : activeYearly === 3
      ? generateLast7YearsData()
      : [];

  const gradient = document.createElement("canvas").getContext("2d");
  const gradientFill = gradient.createLinearGradient(0, 0, 0, 250);
  const gradientFill2 = gradient.createLinearGradient(0, 0, 0, 250);

  gradientFill.addColorStop(0, "rgba(200, 181, 237, 1)"); // Start color
  gradientFill.addColorStop(1, "rgba(255, 255, 255, 1)"); // End color

  gradientFill2.addColorStop(0, "rgba(193, 255, 230, 1)"); // Start color
  gradientFill2.addColorStop(1, "rgba(255, 255, 255, 1)"); // End color

  const formatter = new Intl.NumberFormat("en-IN", {
    maximumFractionDigits: 2,
  });

  const footer = (tooltipItems) => {
    let sum = {};
    let sum2 = {};

    if (activeYearly === 1) {
      tooltipItems.forEach(function (tooltipItem) {
        sum = graphData.filter(
          (itm) =>
            moment(itm.dateormonth, "DD-MM-YYYY HH:mm:ss").format(
              "DD-MM-YY"
            ) === tooltipItem.label
        );
        sum2 = graphData2.filter(
          (itm) =>
            moment(itm.dateormonth, "DD-MM-YYYY HH:mm:ss").format(
              "DD-MM-YY"
            ) === tooltipItem.label
        );
      });

      if (sum.length != 0) {
        const data1Amt = parseFloat(sum[0].totalAmount).toFixed(2);
        const data2Amt = parseFloat(sum2[0].totalAmount).toFixed(2);
        const totalAmtAdd = parseFloat(data1Amt) + parseFloat(data2Amt);
        const yy = formatter.format(totalAmtAdd);

        return `Total Amt: ₹${yy}\n\nMelli:\nAmount Collected: ₹${formatter.format(
          sum[0].totalAmount
        )}\nReceipt Count: ${
          sum[0].receiptcount
        }\n\nRangpo:\nAmount Collected: ₹${formatter.format(
          sum2[0].totalAmount
        )}\nReceipt Count: ${sum2[0].receiptcount}`;
      }
    } else {
      tooltipItems.forEach(function (tooltipItem) {
        sum = graphData.filter((itm) => itm.dateormonth === tooltipItem.label);
        sum2 = graphData2.filter(
          (itm) => itm.dateormonth === tooltipItem.label
        );
      });

      if (sum.length != 0) {
        const data1Amt = parseFloat(sum[0].totalAmount).toFixed(2);
        const data2Amt = parseFloat(sum2[0].totalAmount).toFixed(2);
        const totalAmtAdd = parseFloat(data1Amt) + parseFloat(data2Amt);
        const yy = formatter.format(totalAmtAdd);

        return `Total Amt: ₹${yy}\n\nMelli:\nAmount Collected: ₹${formatter.format(
          sum[0].totalAmount
        )}\nReceipt Count: ${
          sum[0].receiptcount
        }\n\nRangpo:\nAmount Collected: ₹${formatter.format(
          sum2[0].totalAmount
        )}\nReceipt Count: ${sum2[0].receiptcount}`;
      }
    }
  };

  const melliFooter = (tooltipItems) => {
    let sum = {};

    if (activeYearly === 1) {
      tooltipItems.forEach(function (tooltipItem) {
        sum = graphData.filter(
          (itm) =>
            moment(itm.dateormonth, "DD-MM-YYYY HH:mm:ss").format(
              "DD-MM-YY"
            ) === tooltipItem.label
        );
      });
    } else {
      tooltipItems.forEach(function (tooltipItem) {
        sum = graphData.filter((itm) => itm.dateormonth === tooltipItem.label);
      });
    }
    if (sum.length != 0) {
      const yy = formatter.format(sum[0].totalAmount);
      return `Amount Collected : ₹${yy}\nReceipt Count: ${sum[0].receiptcount}`;
    }
  };

  const centralDataset = [
    {
      label: `Melli`,
      data: graphData.map((item) => item.totalAmount),
      borderColor: "rgba(172, 145, 228, 1)",
      backgroundColor: gradientFill,
      tension: 0.5,
      fill: true,
      borderWidth: 1,
    },
    {
      label: "Rangpo",
      data: graphData2.map((item) => item.totalAmount),
      borderColor: "rgb(19, 196, 125)",
      backgroundColor: gradientFill2,
      tension: 0.5,
      fill: true,
      borderWidth: 1,
    },
  ];

  const melliDataset = [
    {
      label: "Amount Collected",
      data: graphData.map((item) => item.totalAmount),
      borderColor: "rgba(172, 145, 228, 1)",
      backgroundColor: gradientFill,
      tension: 0.5,
      fill: true,
      borderWidth: 1,
    },
  ];

  const chartData = {
    labels: data,
    datasets: isActiveCentral ? centralDataset : melliDataset,
  };

  // console.log(chartData);

  const options = {
    responsive: true,
    offset: true,
    stacked: true,
    maintainAspectRatio: false,
    interaction: {
      mode: "nearest",
      axis: "x",
      intersect: false,
    },
    scales: {
      x: {
        grid: {
          display: false,
        },
        border: {
          display: false,
        },
        ticks: {
          font: {
            size: 13,
            weight: "bold",
            family: "Jost",
          },
        },
      },
      y: {
        display: true,
        grid: {
          display: true,
        },
        border: {
          display: false,
        },
        title: {
          display: true,
          text: "Amount (in ₹)",
        },
      },
    },
    plugins: {
      legend: {
        display: true,
        onClick: null,
        position: "top",
        align: "end",
        labels: {
          boxWidth: 13,
          useBorderRadius: true,
          borderRadius: "6px",
        },
      },
      tooltip: {
        displayColors: true,
        yAlign: "bottom",
        backgroundColor: "rgba(254, 235, 230, 1)",
        titleColor: "black",
        bodyColor: "black",
        footerColor: "black",
        callbacks: {
          label: function (context) {
            return null;
          },
          beforeBody: isActiveCentral ? footer : melliFooter,
        },
        bodyFont: {
          size: 17,
          family: "Jost, sans-serif",
        },
        titleFont: {
          size: 16,
          family: "Jost, sans-serif",
        },

        // usePointStyle: true,
      },
      datalabels: {
        display: false,
      },
    },
  };

  return (
    <>
      <div className="graph-header">
        <div className="graph-heading">Toll Collection</div>
        <div className="graph-yearly-filter">
          <div
            className={activeYearly === 1 ? "filter-box active" : "filter-box"}
            onClick={() => handleYearlyFilter(1)}
          >
            Last 7 Days
          </div>
          <div
            className={activeYearly === 2 ? "filter-box active" : "filter-box"}
            onClick={() => handleYearlyFilter(2)}
          >
            Monthly
          </div>
          <div
            className={activeYearly === 3 ? "filter-box active" : "filter-box"}
            onClick={() => handleYearlyFilter(3)}
          >
            Yearly
          </div>
        </div>
        <div className="date-range">
          <div className="flex position-relative">
            <span>
              {details.formatedFromDate !== ""
                ? details.formatedFromDate
                : "From"}
            </span>
            <span>
              <svg
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                onClick={(e) => {
                  setShowCalendar(true);
                  setShowCalendar2(false);
                }}
              >
                <path
                  d="M2.5 8.33333H17.5M5.83333 2.5V4.16667M14.1667 2.5V4.16667M5.16667 17.5H14.8333C15.7667 17.5 16.2335 17.5 16.59 17.3183C16.9036 17.1586 17.1586 16.9036 17.3183 16.59C17.5 16.2335 17.5 15.7667 17.5 14.8333V6.83333C17.5 5.89991 17.5 5.4332 17.3183 5.07668C17.1586 4.76307 16.9036 4.50811 16.59 4.34832C16.2335 4.16667 15.7667 4.16667 14.8333 4.16667H5.16667C4.23325 4.16667 3.76653 4.16667 3.41002 4.34832C3.09641 4.50811 2.84144 4.76307 2.68166 5.07668C2.5 5.4332 2.5 5.89991 2.5 6.83333V14.8333C2.5 15.7667 2.5 16.2335 2.68166 16.59C2.84144 16.9036 3.09641 17.1586 3.41002 17.3183C3.76653 17.5 4.23324 17.5 5.16667 17.5Z"
                  stroke="#6E6284"
                  stroke-width="1.8"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </span>
            {showCalendar && (
              <div className="calendarModal position-absolute">
                <Calendar
                  formatMonthYear={formatMonthYear}
                  tileDisabled={disableWeekends}
                  onChange={handleChange}
                  value={formdate}
                />
              </div>
            )}
          </div>
          <div className="flex position-relative">
            <span>
              {details.formatedToDate !== "" ? details.formatedToDate : "To"}
            </span>
            <span>
              <svg
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                onClick={(e) => {
                  setShowCalendar2(true);
                  setShowCalendar(false);
                }}
              >
                <path
                  d="M2.5 8.33333H17.5M5.83333 2.5V4.16667M14.1667 2.5V4.16667M5.16667 17.5H14.8333C15.7667 17.5 16.2335 17.5 16.59 17.3183C16.9036 17.1586 17.1586 16.9036 17.3183 16.59C17.5 16.2335 17.5 15.7667 17.5 14.8333V6.83333C17.5 5.89991 17.5 5.4332 17.3183 5.07668C17.1586 4.76307 16.9036 4.50811 16.59 4.34832C16.2335 4.16667 15.7667 4.16667 14.8333 4.16667H5.16667C4.23325 4.16667 3.76653 4.16667 3.41002 4.34832C3.09641 4.50811 2.84144 4.76307 2.68166 5.07668C2.5 5.4332 2.5 5.89991 2.5 6.83333V14.8333C2.5 15.7667 2.5 16.2335 2.68166 16.59C2.84144 16.9036 3.09641 17.1586 3.41002 17.3183C3.76653 17.5 4.23324 17.5 5.16667 17.5Z"
                  stroke="#6E6284"
                  stroke-width="1.8"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </span>
            {showCalendar2 && (
              <div className="calendarModal position-absolute">
                <Calendar
                  formatMonthYear={formatMonthYear}
                  tileDisabled={disableWeekends}
                  onChange={handleChange2}
                  value={toDate}
                />
              </div>
            )}
          </div>
        </div>
      </div>

      <div className="">
        {loading ? (
          <>
            <div className="loading-area">
              <div
                class="spinner-border "
                style={{ color: "rgb(247, 177, 140)" }}
                role="status"
              >
                <span class="sr-only"></span>
              </div>
              <span>Data is Loading...</span>
            </div>
          </>
        ) : (
          <>
            <Line data={chartData} options={options} width={600} height={275} />
          </>
        )}
      </div>
    </>
  );
};

export default TollCollection;
